import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { articleList } from "@/mocks/articles";

export default function SEOContent() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-medium text-accent-700 tracking-wider uppercase">
            {t("seo.tagline")}
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mt-3 mb-8">
            {t("seo.title")}
          </h2>

          <div className="space-y-5 text-left max-w-2xl mx-auto">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {t("seo.paragraph1")}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {t("seo.paragraph2")}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {t("seo.paragraph3")}
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/60 pt-14">
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 text-center mb-10">
            {t("seo.articles_heading")}
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {articleList.map((article) => (
              <button
                key={article.slug}
                onClick={() => navigate(`/article/${article.slug}`)}
                className="group relative rounded-xl bg-background-100 border border-background-200/60 p-5 md:p-6 text-left cursor-pointer hover:bg-background-200/70 transition-colors"
              >
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-article-line text-accent-600 text-lg"></i>
                  </div>
                  <div className="min-w-0">
                    <span className="text-sm md:text-[15px] font-semibold text-foreground-900 leading-snug group-hover:text-accent-700 transition-colors line-clamp-2">
                      {article.title}
                    </span>
                    <div className="flex items-center gap-1 mt-2">
                      <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
                        {t("seo.read_article")}
                      </span>
                      <i className="ri-arrow-right-line text-accent-500 text-xs"></i>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}